import { fontSize, type TypographyProps } from '@material-ui/system'
import styled, { css } from 'styled-components'

import { type IStatusLabelProps, type StatusLabelStatus } from '../StatusLabel'
import { IconStyled } from '@ui/elements/Icon'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'

interface IStatusLabelStyledProps extends Pick<TypographyProps, 'fontSize'> {
  type: StatusLabelStatus
  hasIcon?: boolean
  paddingSize: IStatusLabelProps['paddingSize']
}

export const StatusLabelStyled = styled.span<IStatusLabelStyledProps>`
  ${fontSize}

  line-height: 1;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.fontFamily.body};
  padding: ${(props) =>
    props.paddingSize === 'small'
      ? `${props.theme.typography.pxToRem(2)} ${props.theme.typography.pxToRem(8)}`
      : `${props.theme.typography.pxToRem(4)} ${props.theme.typography.pxToRem(8)}`};
  ${(props) =>
    props.hasIcon &&
    css`
      padding-left: ${props.theme.typography.pxToRem(6)};
    `}

  display: inline-flex;
  align-items: center;

  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  color: ${(props) => props.theme.colors.badge[props.type].content};

  background: ${(props) => props.theme.colors.badge[props.type].background};

  > ${IconStyled}, > ${IconComponentStyled} {
    transform: scale(0.75);
    margin-right: ${(props) => props.theme.typography.pxToRem(4)};
  }

  text-wrap: nowrap;
`
